import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import styles from './RainEffect.module.scss'

const RainEffect = ({ intensity = 200 }) => {
  const canvasRef = useRef(null)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return

    const ctx = canvas.getContext('2d')
    if (!ctx) return

    let animationId

    const resizeCanvas = () => {
      canvas.width = window.innerWidth
      canvas.height = window.innerHeight
    }

    resizeCanvas()
    window.addEventListener('resize', resizeCanvas)

    const drops = []
    for (let i = 0; i < intensity; i++) {
      drops.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height - canvas.height,
        length: Math.random() * 20 + 10,
        speed: Math.random() * 5 + 4,
        opacity: Math.random() * 0.3 + 0.1,
        wind: Math.random() * 2 - 1
      })
    }

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      ctx.strokeStyle = 'rgba(174, 194, 224, 0.5)'
      ctx.lineWidth = 1
      ctx.lineCap = 'round'

      drops.forEach(drop => {
        ctx.globalAlpha = drop.opacity
        ctx.beginPath()
        ctx.moveTo(drop.x, drop.y)
        ctx.lineTo(drop.x + drop.wind, drop.y + drop.length)
        ctx.stroke()

        drop.y += drop.speed
        drop.x += drop.wind * 0.2

        if (drop.y > canvas.height) {
          drop.y = -drop.length
          drop.x = Math.random() * canvas.width
        }
      })

      animationId = requestAnimationFrame(animate)
    }

    animate()

    return () => {
      window.removeEventListener('resize', resizeCanvas)
      cancelAnimationFrame(animationId)
    }
  }, [intensity])

  return <canvas ref={canvasRef} className={styles['rain-effect']} />
}

RainEffect.propTypes = {
  intensity: PropTypes.number
}

export default RainEffect
